"use client";
import { palette } from "@/material";
import { InputLabel, InputLabelProps, Stack, StackProps } from "@mui/material";
import { MuiColorInputProps } from "mui-color-input";
import dynamic from "next/dynamic";
import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
const MuiColorInput = dynamic(
  () => import("mui-color-input").then((mod) => mod.MuiColorInput),
  {
    ssr: false,
  }
);
const AppFormControlColorInput = <T extends FieldValues>({
  label,
  labelProps,
  required = false,
  control,
  rules,
  onChangeValueForm,
  name,
  muiColorInputProps,
  ...otherProps
}: AppFormControlColorInputProps<T>) => {
  return (
    <Stack {...otherProps}>
      <InputLabel
        sx={{
          "&": {
            mb: 0.5,
          },
        }}
        required={required}
        {...labelProps}
      >
        {label}
      </InputLabel>
      <Controller
        name={name}
        control={control}
        // rules={{ required, ...rules }}
        render={({ field: { onChange, ...otherColorInputProps } }) => (
          <MuiColorInput
            sx={{
              ".MuiOutlinedInput-notchedOutline": {
                border: "unset",
              },
              "&&:hover .MuiOutlinedInput-notchedOutline": {
                border: `2px solid ${palette.primary.main}`,
                borderRadius: "4px",
              },
              "& .MuiInputBase-root": {
                borderRadius: "4px",
                height: 40,
                "&.Mui-disabled": {
                  backgroundColor: "#f3f4f6",

                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "unset",
                  },
                },
              },
              "& .MuiButtonBase-root": {
                minHeight: 24,
                padding: "8px 8px",
              },
            }}
            format="hex"
            onChange={(value: string) => {
              if (onChangeValueForm instanceof Function)
                onChangeValueForm(value);

              onChange(value);
            }}
            {...otherColorInputProps}
            {...muiColorInputProps}
          />
        )}
      />
    </Stack>
  );
};

export default AppFormControlColorInput;

type AppFormControlColorInputProps<T extends FieldValues> = StackProps & {
  control: Control<any>;
  name: FieldPath<T>;
  label?: string;
  labelProps?: InputLabelProps;
  required?: boolean;
  rules?: RegisterOptions<FieldValues>;
  onChangeValueForm?: (value: string) => void;
  muiColorInputProps?: MuiColorInputProps & any;
};
